import { GET_MEDICINES_ORDER } from './constants';
import { ExtraCharges } from './fetchMedicinesByPrescriptionId';
import fetchWithRefresh from './fetchWithRefresh';
import { Address, CartEntity, CustomerDetails } from './orderMedicineCart';

export interface Response {
    success: boolean;
    data: Data[];
}
export interface Data {
    id: string;
    status: string;
    sub_status: string;
    pxid: string;
    pxurl: string;
    docid: string;
    patientid: string;
    vendorid: string;
    vendorname: string;
    customerDetails: CustomerDetails;
    created_at: string;
    updated_at: string;
    vendor_order_id: string;
    amount: number;
    paidAmount: number;
    totalMRP: number;
    absoluteDiscount: number;
    discountedPrice: number;
    totalAmount: number;
    platformdiscount: number;
    pincode: string;
    address: Address;
    cart?: CartEntity[] | null;
    requestedCart?: CartEntity[] | null;
    paymode: string;
    order_id?: string;
    extra_charges?: ExtraCharges;
    eta?: string;
    eta_display?: string;
    delivered_early_by?: string;
    type?: string;
}

export default (pxId: string = '', orderId: string = ''): Promise<Response> => {
    return fetchWithRefresh(GET_MEDICINES_ORDER(pxId, orderId)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('No order found');
        }
    });
};
